/* global euAdminConfig */

const initialize = () => {
    const domainToReplace = document.querySelector('#saml2Config_help .domain');
    if (domainToReplace) {
        domainToReplace.textContent = euAdminConfig.domain;
    }

    function hideAllSSOTypes() {
        document.querySelectorAll('.sso-config-form-type').forEach((el) => {
            // eslint-disable-next-line no-param-reassign
            el.style.display = 'none';
        });
    }

    function showSSOType(type) {
        hideAllSSOTypes();
        document.querySelector(`.sso-config-form-type.type-${type}`).style.display = 'block';

        document.querySelectorAll('.sso-config-form-type input,.sso-config-form-type select').forEach((el) => {
            if (el.closest(`.type-${type}`)) {
                el.disabled = false;
            } else {
                el.disabled = true;
            }
        });
    }

    document.querySelectorAll('[name="type"]').forEach((el) => {
        el.addEventListener('change', () => {
            showSSOType(document.querySelector('[name="type"]:checked').value);
        });
    });
    showSSOType(document.querySelector('[name="type"]:checked').value);
};

export default initialize;
